import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./App";
import { BehaviorRoot } from "./analytics/BehaviorRoot";
import { watchDisplayScale } from "./display-scale";
import { installDracoDecoderPath } from "./hooks/mood-scene-draco";
import "./styles.css";

document.documentElement.classList.add("dark");
document.documentElement.setAttribute("data-theme", "dark");

installDracoDecoderPath();
watchDisplayScale();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <BehaviorRoot>
        <App />
      </BehaviorRoot>
    </BrowserRouter>
  </StrictMode>,
);
